import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';
import { createUsableUrl } from './createUsableUrl';
import { findAutolinkTextRanges } from './autolinkUtils';

const NAME = 'decorationAutolink';

export const decorationAutolink = (protocol: string) =>
    new Plugin({
        key: new PluginKey(NAME),
        state: {
            init: () => DecorationSet.empty,

            apply: (transaction, oldState) => {
                const { doc } = transaction;

                if (!transaction.docChanged) return oldState;

                const foundMatches = findAutolinkTextRanges(doc);

                return DecorationSet.create(
                    doc,
                    foundMatches.map((m) => {
                        const href = createUsableUrl(m.text, protocol);
                        return Decoration.inline(m.from, m.to, {
                            nodeName: 'a',
                            class: 'autolink',
                            target: '_blank',
                            rel: 'noopener noreferrer nofollow',
                            href,
                        });
                    }),
                );
            },
        },

        props: {
            decorations(state) {
                return this.getState(state);
            },
        },
    });
